import React from 'react';
import { motion } from 'framer-motion';
export function ClosingCTA() {
  return <section id="contacto" className="relative py-32 md:py-48 flex items-center justify-center text-center px-4 overflow-hidden" data-id="element-70">
      <div className="absolute inset-0 bg-forest/80 z-10" data-id="element-71" />
      <img src="https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&q=80" alt="Camino en el bosque" className="absolute inset-0 w-full h-full object-cover" data-id="element-72" />

      <div className="relative z-20 max-w-4xl mx-auto text-bone" data-id="element-73">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-5xl md:text-7xl font-serif mb-8 leading-tight" data-id="element-74">
          El bosque nos une
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-2xl text-bone/80 font-light mb-12 max-w-2xl mx-auto" data-id="element-75">
          Súmate a este esfuerzo por la vida, el territorio y las comunidades
          que lo habitan.
        </motion.p>

        <motion.a href="https://programatefos.com/" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="inline-block bg-clay hover:bg-clay-light text-bone px-10 py-5 text-lg font-medium tracking-wide transition-colors" data-id="element-76">
          Conoce el proyecto
        </motion.a>
      </div>
    </section>;
}